export enum SIGNUP_STEPS {
  BASIC_DETAIL = 'basicDetail',
  COMPANY_DETAIL = 'companyDetail',
  APPROVAL_STATUS = 'approvalStatus'
}
